import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { TrustBoxWidgetComponent } from '@commons/atoms/trust-box-widget/trust-box-widget.component';
import type {
  HeaderButtonNavItem,
  HeaderLinkNavItem,
  HeaderRouterLinkNavItem,
} from '@commons/molecules/menu/menu.component';
import { MenuComponent } from '@commons/molecules/menu/menu.component';
import { LocaleEnum } from '@wizbii/utils/models';
import { trackEvent } from '@wizbii/utils/tracking';

@Component({
  imports: [
    CommonModule,
    RouterModule,
    TrustBoxWidgetComponent,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    MenuComponent,
  ],
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoneyHeaderComponent {
  readonly isTrustpilotEnabled = input<boolean>(true);
  readonly locale = input<LocaleEnum>(LocaleEnum.fr_FR);
  readonly menuItems = input.required<(HeaderButtonNavItem | HeaderLinkNavItem | HeaderRouterLinkNavItem)[][]>();
  readonly resetForm = output();

  readonly trackEvent = trackEvent;
}
